import { Facebook, ArrowUpRight } from "lucide-react";
import { FB_URL } from "@/lib/api";

export const FollowBanner = () => (
  <section className="max-w-5xl mx-auto px-5 sm:px-8 mt-10" data-testid="follow-banner">
    <a
      href={FB_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="follow-fb-button"
      className="group flex flex-col sm:flex-row items-center justify-between gap-5 rounded-2xl bg-[#1877F2] hover:bg-[#145FCC] text-white px-6 sm:px-10 py-6 sm:py-7 shadow-xl shadow-[#1877F2]/25 transition-colors"
    >
      <span className="flex items-center gap-4 text-center sm:text-left">
        <span className="w-14 h-14 rounded-full bg-white/15 flex items-center justify-center flex-shrink-0">
          <Facebook className="w-7 h-7" fill="currentColor" />
        </span>
        <span>
          <span className="block font-type font-bold text-xl sm:text-2xl uppercase tracking-wider leading-tight">Follow us on FB here</span>
          <span className="block text-sm text-white/80 mt-1">Join the R.O.A.N Initiative group — updates, bills and meeting calls.</span>
        </span>
      </span>
      <span className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-white text-[#1877F2] font-type font-bold text-sm uppercase tracking-wider transition-transform group-hover:translate-x-1">
        Open Facebook <ArrowUpRight className="w-4 h-4" />
      </span>
    </a>
  </section>
);
